module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-256.814ff5d.woff2";